import request from '@/utils/request'
import _ from 'lodash'

const baseUrl = '/django_rest/company/wechat-template-message-management'

export default {
  getCompanyWxQrCode (params) {
    return request.get('/wechat/api/company-wechat-qrcode/', { params })
  },
  getCompanyWeChatTemplateMessageList (params) {
    return request.get(`${baseUrl}/`, { params })
  },
  getWeChatTemplateMessageInfo (params) {
    return request.get(`${baseUrl}/`, { params })
  },
  updateWeChatTemplateMessageStatus (params) {
    return request.put(`${baseUrl}/`, params)
  },
  createOrUpdateWeChatTemplateMessage (params) {
    return request.post(`${baseUrl}/`, params)
  },
  getCompanyWeChatTemplateAppAccount () {
    return request.get(`${baseUrl}/app-account/`)
  },
  createOrUpdateWeChatTemplateAppAccount (accountInfo) {
    const data = {}
    const formData = new FormData()
    _.forEach(accountInfo, (val, key) => {
      if (key === 'verify_file') {
        formData.append('file', val)
      } else {
        data[key] = val
      }
    })
    formData.append('data', JSON.stringify(data))
    return request.post(`${baseUrl}/app-account/`, formData)
  },
  getCompanyWeChatAccountTemplateInfoByTemplateId (templateId) {
    return request.get(`/django_rest/company/wechat-account-template/${templateId}/`)
  }
}
